import { ref, shallowRef, type Ref, type ShallowRef } from 'vue';
import { UserCollection } from '/@/modules/user/models/UserCollection';
import { User } from '@/modules/user/models/User';

export const estateAssignableUsers: ShallowRef<UserCollection> = shallowRef(new UserCollection());
export const estateAdministrators: Ref<User[]> = ref([]);
export const professionalUsers: Ref<User[]> = ref([]);
